module.exports = __webpack_public_path__ + "static/media/HHHW.4a5b3c58.pdf";